import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			'& img': {
				width: 'inherit !important',
				height: '1.5rem !important'
			}
		}
	})
);

export interface IAltimetricBadgeProps {
	doi?: string;
	pmid?: string;
	popover?: string;
}

const AltmetricBadge: React.FunctionComponent<IAltimetricBadgeProps> = props => {
	const classes = useStyles();
	const locationRef = useRef<HTMLDivElement>();
	const [hidden, setHidden] = useState(true);
	const attrs = {};

	useEffect(() => {
		const observer = new MutationObserver(mutationsList => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
					setHidden(false);
				}
			}
		});

		const script = document.createElement('script');
		script.async = true;
		script.setAttribute('src', 'https://d1bxh8uas1mnw7.cloudfront.net/assets/embed.js');

		document.body.appendChild(script);
		observer.observe(locationRef.current, { childList: true });

		return () => {
			document.body.removeChild(script);
		};
	}, []);

	if (props.doi) {
		attrs['data-doi'] = props.doi;
	} else if (props.pmid) {
		attrs['data-pmid'] = props.pmid;
	}

	return (
		<div
			hidden={hidden}
			ref={locationRef}
			className={clsx('altmetric-embed', classes.root)}
			data-badge-popover={props.popover ?? 'top'}
			data-badge-type="2"
			data-hide-no-mentions="true"
			data-link-target="_blank"
			{...attrs}
		/>
	);
};

export default AltmetricBadge;
